export default {
  zh: {
    leftSider: {
      title: '可选字段',
      search: '查找字段',
      tip: '拖拽字段到报告',
      noData: '无可选字段',
    },
  },
  en: {
    leftSider: {
      title: 'Available Fields',
      search: 'Quick Find',
      tip: 'Drag and drop to add fields to the report',
      noData: 'No available fields',
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/ReportSetup/i18n.js